import { render, staticRenderFns } from "./CustomerPop.vue?vue&type=template&id=2f0e9bc7&scoped=true&"
import script from "./CustomerPop.vue?vue&type=script&lang=js&"
export * from "./CustomerPop.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPop.vue?vue&type=style&index=0&id=2f0e9bc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e9bc7",
  null
  
)

export default component.exports